var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIImmunizations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.208 25.544c1.904-0.609 3.938 0.44 4.548 2.347 0.609 1.9-0.442 3.938-2.346 4.549l-9.838 3.144c-1.139 0.365-2.387 0.141-3.331-0.597l-4.069-3.184 8.835 31.777h-25.74v-40.372c0-2.385 1.935-4.317 4.319-4.317h6.435c0.918 0 1.764 0.293 2.46 0.836 0 0 8.395 6.566 10.711 8.379l8.016-2.563zM17.486 37.718h-3.904v-3.909h-4.659v3.909h-3.89v4.673h3.89v3.889h4.659v-3.889h3.904v-4.673z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.655 16.951c4.289 0 7.767-3.476 7.767-7.77 0-4.287-3.477-7.768-7.767-7.768-4.291 0-7.769 3.481-7.769 7.768-0 4.293 3.477 7.77 7.769 7.77z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.37 16.979c4.293 0 7.779-3.483 7.779-7.777 0-4.301-3.486-7.787-7.779-7.787-4.299 0-7.781 3.486-7.781 7.787 0 4.294 3.482 7.777 7.781 7.777z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.020 19.069c-3.184 0-4.628 1.089-5.837 2.975l-0.782 1.504-4.547-1.328 0.192-1.239-10.857-2.432-0.304 1.354-2.031-0.452 0.302-1.358-0.815-0.18-0.932 4.16 0.811 0.18 0.311-1.358 2.031 0.454-0.304 1.361 10.86 2.432 0.351-1.274 4.399 0.707-11.335 21.8c-0.876 1.752-0.166 3.879 1.588 4.757 1.752 0.878 3.881 0.166 4.764-1.586l9.456-18.351h1.551v32.386h11.147v-44.511h-10.018z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIImmunizations);
export default __webpack_public_path__ + "static/media/i-immunizations.e108b979.svg";
export { ForwardRef as ReactComponent };